/* jshint esversion: 6 */
import React from 'react';
import PropTypes from 'prop-types';
import { outputAccountFromSocial, outputAccountInactive } from '@/lib/output-account.ts';
import { ConnectNewTile, OutputTile } from '@/shadcn/components/NewAutomation/OutputTile.tsx';

/*
 * One account in the posting tool's "Select social accounts" list, drawn as the
 * shared destination tile (shadcn/NewAutomation/OutputTile) — the same artwork
 * the destinations grid, the social modal and `SocialButton tile` use.
 *
 * The tile is rendered inert and the WRAPPER owns the click, because
 * PostingTool.onSocialClick reads `e.currentTarget.dataset.socialid` and
 * `.socialtype`. Handing OutputTile an `onSelect` would give the handler an
 * account object where it expects an event.
 *
 * `.tw-root` is required — Tailwind's preflight here is scoped to that class,
 * and outside it the tile inherits dlvrit.min.css's resets and collapses.
 *
 * A refusal (X disabled, a second YouTube channel) is drawn by the tile's own
 * `disabled` affordance rather than a bespoke hover bubble. The click still
 * reaches onSocialClick, which early-returns for both cases — that handler
 * stays the single source of the policy, as it was when the bubble was
 * decoration over a live button.
 */
class PostSocialButton extends React.Component {
    render() {
        const wrapperClass = 'tw-root tw:relative tw:inline-block tw:w-[130px] tw:px-1.5 tw:py-2 tw:align-top';

        if (this.props.connect) {
            return (
                <div className={wrapperClass}
                        role="button"
                        aria-label="Connect New Social"
                        onClick={this.props.onClick}
                        data-socialid={0}>
                    <ConnectNewTile label="Add" />
                </div>
            );
        }

        const constants = this.props.app.config.constants,
            social = this.props.social;

        let disabledReason = '';

        if (social.psID === constants.POST_SVC_TWITTER && this.props.app.config.twitterDisabled) {
            disabledReason = 'X (Twitter) is unavailable';
        } else if (!this.props.isSelectable && social.psID === constants.POST_SVC_YOUTUBE) {
            disabledReason = 'Choose one YouTube channel per post';
        }

        return (
            <div className={wrapperClass}
                    onClick={this.props.onClick}
                    data-socialid={social.id}
                    data-socialtype={social.psID}>
                <OutputTile
                    account={outputAccountFromSocial(social, {
                        constants: constants,
                        selected: this.props.isActive,
                        inactive: outputAccountInactive(social),
                        disabledReason: disabledReason
                    })} />
            </div>
        );
    }
};

PostSocialButton.displayName = "PostSocialButton";

PostSocialButton.propTypes = {
    social: PropTypes.object,
    isActive: PropTypes.bool,
    isSelectable: PropTypes.bool,
    connect: PropTypes.bool,
    onClick: PropTypes.func
};

PostSocialButton.defaultProps = {
    social: {},
    isActive: false,
    isSelectable: true,
    connect: false
};

export default PostSocialButton;
